import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Avoid smooth on mobile to reduce jank when route changes frequently
    const isMobile = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;
    window.scrollTo({ top: 0, behavior: isMobile ? 'auto' : 'smooth' });
  }, [pathname, search]);
  return null;
};

export default ScrollToTop;


